<template>
    <div>
        <!-- delete dialog -->
        <delete-dialog ref="DeleteDialog" @on-delete="needToResetItems = true; filter()">
            <p class="mb-0 text-body-1">
               {{('are-you-sure-you-want-to')}} <span class="red--text uppercase--text">{{$t('delete')}}</span> 
               {{$t('the-visit') + $t('?')}}
            </p>
        </delete-dialog>
        <!-- visit details dialog -->
        <v-dialog
            v-model="dialog"
            transition="dialog-transition"
            max-width="700"
            persistent
            @keydown.esc="dialog = false"
        >
            <!-- dialog content -->
            <v-card>
                <div class="d-flex justify-end background-title-card white--text">
                    <v-card-title
                        class="d-flex w-100 justify-center py-1 d-flex"
                    >
                        {{$t('visit-details')}}
                    </v-card-title>
                    <v-btn icon @click="dialog = false; view = false" class="me-2">
                        <v-icon color="white" > mdi-close-circle-outline </v-icon>
                    </v-btn>
                </div>
                <v-card-text class="pb-0 pt-1 px-3">
                    <!-- dialog content -->
                    <!-- samples table -->
                    <div>
                        <p class="text-body-2 font-weight-bold my-1 mb-2">
                            {{$t('VisitsGroupByMedicalRep.distributed-samples')}}
                        </p>
                        <bee-handy-smart-table
                            ref="sampleTable"
                            v-model="sampleTableInputs"
                            :items="entriesSamples"
                            :headers="headerSamples"
                            zebra
                            dense
                            height="auto"
                            pagination-on-scroll
                            :show-add-row="!view"
                            :editable-rows="!loading"
                            @keypress.enter="isEditSample ? editSamples() : addSamples()"
                        >
                            <!-- product name -->
                            <template v-slot:input.materialId="{ on, attr }">
                                <v-autocomplete
                                    :items="materials"
                                    item-value="id"
                                    item-text="name"
                                    v-on="on"
                                    v-bind="attr"
                                ></v-autocomplete>
                            </template>

                            <!-- action column -->
                            <template v-slot:item.actions="{ item, index }">
                                <div class="d-flex">
                                    <tooltip :text="$t('edit-doctor')" top>
                                        <v-btn
                                            icon
                                            small
                                            color="edit-color"
                                            :disabled="loading"
                                            @click="() => {
                                                $refs.sampleTable.activeEditForRow(index);
                                                editAddressRowIndex = index;
                                                isEditSample = true;
                                                $nextTick(() => {
                                                    $refs.sampleTable.resetInputsFocus()
                                                })
                                            }"
                                        >
                                            <v-icon>
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </tooltip>
                                    
                                    <tooltip :text="$t('delete-doctor')" top>
                                        <v-btn
                                            icon
                                            small
                                            @click="deleteSamplesRow({ id: item.id, index })"
                                            color="alert-color"
                                        >
                                            <v-icon>
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </tooltip>
                                </div>
                            </template>
                        </bee-handy-smart-table>
                    </div> 

                    <v-row class="mt-1">
                        <!-- other samples table -->
                        <v-col cols="4">
                            <v-text-field
                                v-model="others"
                                class="mb-1"
                                label="Other samples"
                                dense
                                outlined
                                hide-details
                                :readonly="view"
                            >
                            </v-text-field>
                        </v-col>

                        <v-divider vertical class="my-1" />

                        <!-- durationInMinutes-->
                        <v-col cols="4">
                            <v-text-field
                                v-model.number="durationInMinutes"
                                class="mb-1"
                                :label="$t('inputs.duration-in-minutes')"
                                dense
                                outlined
                                hide-details
                                type="number"
                                hide-spin-buttons
                                :readonly="view"
                            >
                            </v-text-field>
                        </v-col>
                        <v-divider vertical class="my-1" />

                        <!-- coreMessage -->
                        <v-col cols="4">
                            <v-text-field
                                v-model="coreMessage"
                                class="mb-1"
                                :label="$t('inputs.core-message')"
                                dense
                                outlined
                                hide-details
                                :readonly="view"
                            >
                            </v-text-field>
                        </v-col>
                        
                        <v-divider vertical class="my-1" />

                        <!-- Notes -->
                        <v-col cols="4">
                            <v-text-field
                                v-model="notes"
                                class="mb-1"
                                :label="('inputs.notes')"
                                dense
                                outlined
                                hide-details
                                :readonly="view"
                            >
                            </v-text-field>
                        </v-col>
                        <v-divider vertical class="my-1" />

                        <!-- Objections-->
                        <v-col cols="4">
                            <v-text-field
                                v-model="objections"
                                class="mb-1"
                                :label="('inputs.objections')"
                                dense
                                outlined
                                hide-details
                                :readonly="view"
                            >
                            </v-text-field>
                        </v-col>

                        <!-- notes -->
                        <v-col cols="4" >
                            <v-text-field
                                v-model="nextCall"
                                class="mb-1"
                                :label="$t('inputs.next-call')"
                                dense
                                outlined
                                hide-details
                                :readonly="view"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <!-- Unavailable octo Products -->
                    <div v-if="visitsConfig?.UnavailableMaterials" class="mt-4">
                        <v-autocomplete
                            v-model="unavailablesMaterials"
                            :items="materials"
                            item-value="id"
                            item-text="name"
                            dense
                            outlined
                            hide-details
                            :label="$t('inputs.unavailable-products')"
                            multiple
                            :readonly="view"
                        />
                    </div>

                    <!-- competitive samples  -->
                    <div v-if="visitsConfig?.CompetetiveSample" class="my-3">
                        <v-textarea
                        	v-model="competitiveSamples"
                        	:label="$t('inputs.competitors')"
                        	outlined
                        	dense
                        	hide-details
                        	rows="1"
                        	:readonly="view"
                        />
                    </div>

                    <!-- center notes -->
                    <div v-if="visitsConfig?.NextVisitNotes">
                        <v-text-field
                            v-model="centerNotes"
                            class="mb-1"
                            :label="$t('inputs.center-notes')"
                            dense
                            outlined
                            hide-details
                            :readonly="view"
                        >
                        </v-text-field>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn
                        v-if="!view"
                    	text
                    	color="success"
                    	@click="update()"
                    	:loading="submitLoading"
                    >
                        {{$t('save')}}
                    </v-btn>
                    <!-- dialog active button -->
                    <v-btn
                    	text
                    	@click="dialog = false; view = false"
                    	:disabled="submitLoading"
                    >
                        {{$t('close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- map dialog -->
        <v-dialog eager width="800" v-model="showMap">
            <v-card>
                <v-card-title>
                    {{$t('Visits.select-customer-location')}}
                </v-card-title>
                <v-card-text>
                    <v-card height="400">
                        <Map
                            v-if="showMap"
                            :points.sync="map"
                            :center.sync="map[0]"
                        ></Map>
                    </v-card>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn 
                        text
                        @click="map = []; showMap = false"
                    >
                        {{$t('close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- filter -->
        <v-form @submit.prevent="filter">
            <v-row class="py-3 mx-2">
                <!-- city region filter -->
                <v-col lg="4" md="5" sm="8" cols="12" class="pa-1">
                    <v-row class="d-flex justify-space-between ma-0">
                        <!-- city name -->
                        <v-col 
                            md="5" 
                            sm="4" 
                            cols="6" 
                            class="pa-0 pe-1"
                            :class="{ 
                                'pe-1': $i18n.locale === 'en',
                                'ps-1': $i18n.locale === 'ar'
                            }"
                        >
                            <v-autocomplete
                                v-model="cityId"
                                :items="cities"
                                item-text="name"
                                item-value="id"
                                :label="$t('inputs.city')"
                                dense
                                prepend-icon="mdi-map-marker-multiple"
                                hide-details
                                append-icon
                                :disabled="loading"
                                @change="fetchRegionsDueCity"
                                outlined
                                multiple
                                clearable
                                :search-input.sync="searchCityId"
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item
                                        ripple
                                        @click="toggleCities"
                                    >
                                        <v-list-item-action>
                                            <v-icon>
                                                {{ iconCities }}
                                            </v-icon>
                                        </v-list-item-action>
                                        
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ $t('select-all') }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>

                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                        (+{{ cityId.length - 1 }})
                                    </span>
                                </template>
                            </v-autocomplete>
                        </v-col>
        
                        <!-- region -->
                        <v-col md="7" sm="8" cols="6" class="pa-0">
                            <v-autocomplete
                                v-model="regionIds"
                                :items="regionsAll.filter(c => cityId.includes(c.cityId))"
                                item-text="name"
                                item-value="id"
                                :label="managementHierarchyRegions ? $t('inputs.areas') : $t('inputs.region')"
                                dense
                                multiple
                                clearable
                                hide-details
                                append-icon
                                @change="fetchEntitiesDueRegion"
                                :loading="regionsLoading"
                                :disabled="loading || regionsLoading || cityId === []"
                                outlined
                                :search-input.sync="searchRegion"
                                :return-object="false"
                                append-outer-icon="mdi-select-search"
                                @click:append-outer="getMedical()"
                            >
                            
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                        (+{{ regionIds.length - 1 }})
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item ripple @click="toggle">
                                        <v-list-item-action>
                                            <v-icon>
                                                {{ icon }}
                                            </v-icon>
                                        </v-list-item-action>
                                        
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{$t('select-all')}}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col md="auto" sm="12" cols="auto" :align-self="$vuetify.breakpoint.smAndDown ? 'center' : 'start' " class="pa-0">
                    <v-radio-group
                        v-model="dateType"
                        row
                        class="mt-1"
                        hide-details
                    >
                        <v-radio
                            :label="$t('daily-date')"
                            value="1"
                            :disabled="loading"
                        ></v-radio>
                        <v-radio
                            :label="$t('from-date') + ' / ' + $t('to-date')"
                            value="2"
                            :disabled="loading"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col v-if="dateType === '2'" md="2" sm="6" cols="12" class="pa-1" >
                    <bee-date-picker
                        v-model="startDate"
                        :input-label="$t('inputs.start-date')"
                        menu-picker
                        dense
                        hide-details
                        :input-props="{
                            outlined: true,
                            dense: true
                        }"
                        :allowed-dates="disableDates"
                    ></bee-date-picker>
                </v-col>

                <!-- end date -->
                <v-col v-if="dateType === '2'" md="2" sm="6" cols="12" class="pa-1">
                    <bee-date-picker
                        v-model="endDate"
                        :input-label="$t('inputs.end-date')"
                        menu-picker
                        dense
                        hide-details
                        :input-props="{
                            outlined: true,
                            dense: true
                        }"
                        :allowed-dates="disableDates"
                    ></bee-date-picker>
                </v-col>
                <!-- filter -->
                <v-col v-if="dateType === '1'" cols="12" sm="6" md="3" class="pa-1">
                    <bee-date-input
                        v-model="date"
                        :append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left' "
                        :prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right' "
                        :label="$t('inputs.date')"
                        input-format-order="DD-MM-YYYY"
                        dense
                        :loading="loading"
                        :disabled="loading"
                        hide-details
                        @click:append="
                            addDate();
                            filter()
                        "
                        @click:prepend="
                            subDate();
                            filter()
                        "
                    ></bee-date-input>
                </v-col>
                
                <!-- medical rep -->
                <v-col md="3" sm="6" cols="12" class="pa-1 d-flex align-start">
                    <v-autocomplete
                        v-model="medicalRepId"
                        :items="
                            regionIds.length === 0 
                                ? medicalRepsBrief.filter(c => c.employeeType === userType.medicalRep) 
                                : medicalRepsForRegion.filter(c => c.employeeType === userType.medicalRep)
                        "   
                        item-text="name"
                        item-value="id"
                        :label="$t('inputs.medical-rep')"
                        prepend-icon="mdi-account-tie"
                        hide-details
                        clearable
                        :disabled="loading"
                        outlined
                        dense
                        multiple
                        :loading="loadingMedicalForRegion"
                    >
                        <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                            <span
                                v-if="index === 1"
                                class="grey--text text-caption"
                            >
                                (+{{ medicalRepId.length - 1 }})
                            </span>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col class="d-flex justify-start pa-1" align-self="center">
                    <v-btn
                        color="success"
                        class="px-sm-4 mx-2"
                        :loading="loading"
                        :disabled="loading"
                        type="submit"
                        small
                        @click="needToResetItems = true; filter()"
                    >
                        <v-icon> mdi-magnify </v-icon>
                        {{$t('search')}}
                    </v-btn>
                    <v-btn
                        class="px-sm-4"
                        :disabled="loading"
                        color="alert-color white--text"
                        small
                        @click="resetFilter(); filter()"
                    >
                        {{$t('reset')}}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    
        <bee-handy-table
			ref="table"
			:headers="headers"
			:items="visitsOrder"
			dense
			class="my-2 px-2 mx-2"
			:loading="loading"
			hide-inputs-details
			:data-table-props="{
                singleExpand: true,
				expandedSync: expanded,
				showExpand: true,
                itemKey: 'employeeId',
                disableSort: true,
			}"
            zebra
            height="auto"
            :items-per-page="-1"
            :shown-rows-text="$t('shown-rows')"
            hide-default-footer
            
        >
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="tab">
                    <bee-handy-table
						:headers="headVisitFromDate"
						:items="item.visits.map(c => ({ ...c, id: Math.random() }))"
						hide-default-footer
						class="tab"
						table-class="baby-blue rounded-0 elevation-0"
                        zebra
                        :data-table-props="{
                            disableSort: true,
                            expandedSync: expandedT,
                            showExpand: true,
                            itemKey: 'id',
			            }"
                        pagination-on-scroll
                        :items-per-page="-1"
                        height="auto"
					>

                        <template v-slot:item.actionLocation="{ item }">
                            <v-btn 
                                @click="
                                    map = item.visits.map(c => ({
                                        lat: c.latitude,
                                        lng: c.longitude
                                    }));
                                    showMap = true
                                " 
                                icon 
                                color="orange darken-2"
                                :disabled="loading"
                            > 
                                <v-icon>
                                    mdi-map-marker 
                                </v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="tab">
                                <bee-handy-table
                                    :headers="headVisits"
                                    :items="item.visits.map(c => ({ ...c, id: Math.random() }))"
                                    hide-default-footer
                                    class="tab"
                                    table-class="baby-blue rounded-0 elevation-0"
                                    :items-per-page="-1"
                                    :data-table-props="{
                                        disableSort: true,             
                                        singleExpand: true,
                                        itemKey: 'id'
                                    }"
                                    height="auto"
                                    zebra
                                >
                                    <template v-slot:item.actions="{ item }">
                                        <v-btn 
                                            icon 
                                            color="success" 
                                            :to="{
                                                name: 'visits',
                                                query: {
                                                    visitId: item.id,
                                                    date: dateType === '1' ? date : startDate,
                                                    endDate: dateType === '2' ? endDate : null
                                                }
                                            }"
                                            :disabled="loading"
                                        >
                                            <v-icon>
                                                mdi-eye
                                            </v-icon>
                                        </v-btn>

                                        <tooltip :text="$t('print')" top>
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ attr, on }">
                                                    <v-btn
                                                        small
                                                        depressed
                                                        v-on="on"
                                                        v-bind="attr"
                                                        @click="invoiceId = item.id"
                                                        color="transparent"
                                                        :loading="loading && invoiceId === item.id"
                                                        :disabled="loading"
                                                        icon
                                                    >
                                                        <v-icon color="primary">mdi-printer</v-icon>
                                                    </v-btn>
                                                </template>

                                                <v-list dense>
                                                    <v-list-item @click="invoiceId = item.id, printReport(invoiceId, true)">
                                                        <v-list-item-title>
                                                            {{ $t('invoices.office-invoice') }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="invoiceId = item.id, printReport(invoiceId, false)">
                                                        <v-list-item-title>
                                                            {{ $t('invoices.pos-invoice') }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </tooltip>
                                    </template>
                                </bee-handy-table>
                            </td>
                        </template>

                        <!-- action column -->
                        <!-- <template v-slot:item.actions="{ item, index }">
                            <div class="d-flex">
                                <v-btn
                                    icon
                                    small
                                    color="primary"
                                    :loading="loadingView[index] && view"
                                    :disabled="loading || Boolean($route.query.preview)"
                                    @click="view = true; visitId = item.id; loadingView[index] = true; fetchVisitData(null, item.id, index)"
                                >
                                    <v-icon >mdi-eye</v-icon>
                                </v-btn>
                                <v-btn
                                    icon
                                    small
                                    color="success"
                                    :loading="loadingView[index] && !view"
                                    @click="visitId = item.id; loadingView[index] = true; fetchVisitData(null, item.id, index)"
                                >
                                    <v-icon>
                                        mdi-pencil
                                    </v-icon>
                                </v-btn>

                                <v-btn
                                    icon
                                    small
                                    color="red lighten-1"
                                    @click="$refs.DeleteDialog.activeDeleteDialog(item.id, 'visits')"
                                >
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </div>
                        </template> -->
                    </bee-handy-table>
                </td>
            </template>

            <!-- actions -->
			<!-- <template v-slot:item.action="{ item }">
                <tooltip text="Edit visit" top>
                    <v-btn
                        icon
                        small
                        color="edit-color"
                        :loading="visitId === item.id"
                        :disabled="loading || Boolean($route.query.preview)"
                        @click="visitId = item.id; fetchVisitData(tabs.map(c => c.id)[tab], item.id);"
                    >
                        <v-icon >mdi-pencil</v-icon>
                    </v-btn>
                </tooltip>

                <tooltip text="Delete" top>
                    <v-btn
                        icon
                        small
                        color="red lighten-1"
                        @click="$refs.DeleteDialog.activeDeleteDialog(item.id, 'visits')"
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </tooltip>
			</template> -->
        </bee-handy-table>
    </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import Tooltip from '@/components/Tooltip'
import { userType } from '@/helpers/enums'
import DeleteDialog from '@/components/DeleteDialog'
import { managementHierarchyRegions, addLocationByMap, isDisabledFriday, enableVacations, addPrice } from '@/configs/global.config'
import Map from '@/components/Map.vue'
import { disableDates } from '@/helpers/functions'
export default {
    components: {
        Tooltip,
        DeleteDialog,
        Map
    },

    data() {
        return {
            submitLoading: false,
            view: false,
            entriesSamples: [],
            materialsEmployee: [],
            isEditSample: null,
            sampleTableInputs: {},
            editAddressRowIndex: null,
            createdAtForVisit: null,
            entityIForRow: null,
            // dialog: false,
            searchCityId: null,
            searchRegion: null,
            dateType: '1',
            loadingView: [
                false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,
            ],
            startDate: null,
            endDate: null,
            dialog: false,
            userType,
            cityId: [],
            regionIds: [],
            regionsLoading: false,
            medicalRepId: [],
            date: null,
            needToResetShownRows: false,
            selections:{
                label: ['Customer', 'Doctor', 'Pharmacy', 'Center'],
                entities: [],
            },
            loading: false,
            expanded: [],
            expandedT: [],
			singleExpand: false,

            // details visit
            samples: [],
            others: null,
            notes: null,
            objections: null,
            coreMessage: null,
            durationInMinutes: 0,
            nextCall: null,
            unavailablesMaterials: [],
            competitiveSamples: [],
            centerNotes: null,
            scrollOptions: {},
            serverItemsLength: 0,
            needToResetItems: false,
            visits: [],
            managementHierarchyRegions,
            totalVisits: null,
            showMap: false,
            addLocationByMap,
            map: [],
            loadingMedicalForRegion: false,
            medicalRepsForRegion: [],
            isDisabledFriday,
            enableVacations,
            disableDates,
            invoiceId: null,
            addPrice
        }
    },

    computed: {
        ...mapState({
            cities: state => state.cities.cities,
            regionsAll: state => state.regions.regionsAll,
            medicalRepsBrief: state => state.medicalreps.medicalRepsBrief,
            specialties: state => state.specialties.specialties,
            visitsOrder: state => state.visits.visitsOrder,
            materials: state => state.materials.materials,
            vacationsDayDetails: state => state.vacations.vacationsDayDetails,
            visitsConfig: state => state.configuration.configurations.visitsConfig
        }),
        ...mapGetters({
            getMedicalRepById: 'medicalreps/getMedicalRepById',
            getMaterialById: 'materials/getMaterialById',
            getVisitOrderByMedicalRep: 'visits/getVisitOrderByMedicalRep',
            getCityById: 'cities/getCityById',
            getRegionAllById: 'regions/getRegionAllById'
        }),
        headers() {
            return [
                {
                    text: this.$t('headers.employee'),
                    name: 'employeeName',
                    value: 'employeeName'
                },
                {
                    text: this.$t('headers.team'),
                    name: 'teamName',
                    value: 'teamName'
                },
                {
                    text: this.$t('headers.number-of-visits'),
                    name: 'totalVisitCount',
                    value: 'employeeId',
                    setValueExpr: (val) => this.getVisitOrderByMedicalRep(val)?.doneVisitConut + '/' + this.getVisitOrderByMedicalRep(val)?.totalVisitConut
                },
            ]
        },
        headVisitFromDate() {
            const headers = [
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD'),
                    width: '50%'
                },
                {
                    text: this.$t('headers.note'),
                    name: 'dailyNote',
                    value: 'dailyNote',
                    width: '50%'
                }
            ]
            if (this.addLocationByMap) {
                headers.push({
                    text: '',
                    name: 'actionLocation',
                    value: 'actionLocation',
                    noInput: true
                })
            }
            return headers
        },
        
        headVisits() {
            return [
                {
                    text: this.$t('headers.entity-name'),
                    name: 'entityName',
                    value: 'entityName'
                },
                {
                    text: this.$t('headers.specialty'),
                    name: 'entitySpecialtyName',
                    value: 'entitySpecialtyName',
                    setValueExpr: val => val.length ? val.join(',') : null
                },
                addPrice ? {
                    text: this.$t('headers.amount-received'),
                    value: 'amountReceived',
                    name: 'amount-received',
                    type: 'number',
                    align: 'start',
                } : null,
                {
                    text: this.$t('headers.city'),
                    name: 'entityCityName',
                    value: 'entityCityName'
                },
                {
                    text: !managementHierarchyRegions ? this.$t('headers.region') : this.$t('headers.area'),
                    name: 'entityRegionName',
                    value: 'entityRegionName',
                },
                {
                    text: this.$t('headers.class'),
                    name: 'entityWorkloadValue',
                    value: 'entityWorkloadValue'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ].filter(c => c !== null)
        },

        headerSamples() {
            const headers = [
                {
                    text: 'Samples',
                    name: 'materialId',
                    value: 'materialId',
                    setValueExpr: val => this.getMaterialById(val)?.name
                },
                {
                    text: 'quantity',
                    name: 'amount',
                    value: 'amount',
                    type: 'number'
                }
            ]
            if (!this.view) {
                headers.push({
                    text: 'actions',
                    name: 'actions',
                    value: 'actions',
                    noInput: true
                })
            }
            return headers
        },
        
        selectedAllCities () {
            return this.cityId.length === this.cities.length;
        },

        iconCities () {
            if (this.selectedAllCities) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },

        selectedAllRegions () {
            return this.regionIds.length === this.regionsAll.filter(c => this.cityId?.includes(c.cityId)).length;
        },

        icon() {
            if (this.selectedAllRegions) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },
    },

    methods: {
        moment,
        
        deleteSamplesRow(rowData) {
            this.$refs.sampleTable.resetEdit();
			this.isEditSample = false;
			this.entriesSamples.splice(rowData.index, 1);

            for (let i = 0; i < this.entriesSamples.length; i++) {
                if (this.entriesSamples[i].id > rowData.id) {
                    this.entriesSamples[i].id--;
                }
            }
			
			this.$nextTick(() => {
				this.$refs.sampleTableInputs.resetInputs();
				this.$refs.sampleTableInputs.resetInputsFocus()
			})
		},
        editSamples() {
            if (this.$refs.sampleTable.validate()) {
                this.entriesSamples[this.editAddressRowIndex].materialId = this.sampleTableInputs.materialId
                this.entriesSamples[this.editAddressRowIndex].amount = this.sampleTableInputs.amount
                
                this.$refs.sampleTable.resetEdit();
                this.isEditSample = false;
                this.$nextTick(() => {
                    this.$refs.sampleTable.resetInputs();
					this.$refs.sampleTable.resetInputsFocus()
                })
			} 
        },

        addSamples() {
            if (this.$refs.sampleTable.validate()) {
                const itemInTable = this.entriesSamples.find(c => c.materialId === this.sampleTableInputs.materialId);
                if (itemInTable) {
                    itemInTable.amount = itemInTable.amount + 1
                } else {
                    this.entriesSamples.push({
                        ...this.sampleTableInputs,
                    })
                    this.entriesSamples.map((c, index) => ({ ...c, id: index }))
                }
                this.$refs.sampleTable.resetInputs();
                this.$refs.sampleTable.resetInputsFocus();
            }
        },
        
        fetchRegionsDueCity(){
            this.entityId = null
            this.selections.entities = [];
            this.regionIds = [];
            if (!this.cityId) return;
            this.regionsAll.forEach(region => {
                if (this.cityId.includes(region.cityId)) {
                    this.regionIds.push(region.id);
                }
            });

            this.selections.entities = [];
            if (this.regionIds.length === 0) return;

            this.entityLoading = true;
            this.searchCityId = null

            if (this.regionIds.length) {
                this.loadingMedicalForRegion = true
                this.$store.dispatch('medicalreps/fetchAllBrief', { regionIds: this.regionIds }).then((data) => {
                    this.medicalRepsForRegion = data
                }).finally(() => {
                    this.loadingMedicalForRegion = false
                })
            }
        },
        
        // select all inputs
        toggleCities () {
            this.$nextTick(() => {
                if (this.selectedAllCities) {
                    this.cityId = []
                    this.regionIds = []
                } 
                else {
                    this.cityId = this.cities.map(c => c.id);
                    this.fetchRegionsDueCity()
                }
            })
        },

        toggle () {
            this.$nextTick(() => {
                if (this.selectedAllRegions) {
                    this.regionIds = []
                } 
                else {
                    this.regionIds = []
                    this.regionIds = this.regionsAll.filter(c => this.cityId.includes(c.cityId)).map(c => c.id);
                }
            })
        },
        fetchEntitiesDueRegion(){
            this.searchRegion = null
            this.selections.entities = [];
            if (this.regionIds.length === 0) return;

            this.entityLoading = true;
            this.$store.dispatch('entities/fetchByFilter', {
                // type: this.entityTypeForCurrentTab,
                regionIds: this.regionIds,
                nonDeleted: true,
                OrderByName: true,
                WithVisitsCount: false
            })
            .then((response) => {
                this.selections.entities = response.data;
            })
            .finally(() => {
                this.entityLoading = false
            })
        },

        addDate () {
            this.date = moment(this.date).add(1, 'day').format('YYYY-MM-DD');
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) || 
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.addDate()
            }
            return this.date
        },

        subDate() {
            this.date = moment(this.date).subtract(1, 'day').format('YYYY-MM-DD')
            if (
                (this.moment(this.date).format('dddd') === 'Friday' && this.isDisabledFriday) ||
                (this.enableVacations && this.vacationsDayDetails.includes(this.date))
            ) {
                this.subDate()
            }
            return this.date
        },

        filter(isFirstLoad = false) {
            this.loading = true;

            return this.$store.dispatch('visits/fetchVisitsOrder', {
                FromDate: this.dateType === '1' ? this.date : this.startDate, 
                ToDate: this.dateType === '1' ? this.date : this.endDate,
                EmployeeIds: this.medicalRepId,
                RegionIds: this.regionIds.length ? this.regionIds : null, 
            }).then((data) => {
                // if (this.needToResetShownRows) {
                //     this.$refs.table.resetShownRows();
                //     this.needToResetShownRows = false;
                // }
                // this.totalVisits = total;
                // this.$refs.table.addScrollItems(data);
                // this.serverItemsLength = this.totalVisits;
            }).finally(() => {
                this.loading = false;
            })
        },

        fetchVisitData(type, visitId, index){
            this.$store.dispatch('visits/fetchById', { id: visitId })
            .then((data) => {
                this.entriesSamples = data.materialAmounts.map((c, index) => ({ ...c, id: index }));
                this.others = data.otherSamples;
                this.notes = data.notes;
                this.objections = data.objections;
                this.nextCall = data.purpose;
                this.coreMessage = data.coreMessage;
                this.durationInMinutes = data.durationInMinutes;

                this.unavailablesMaterials = data.unavailableMaterialIds;
                this.competitiveSamples = data.competitiveSamples.join(', ');
                this.centerNotes = null;
                
                this.dialog = true;
                this.entityIForRow = data.entityId
                this.createdAtForVisit = data.createdAt

                // if (type === entityType.pharmacy || this.tab === 0) {
                    // data.unavailableMaterialIds.forEach((element) => {
                    //     this.unavailablesMaterials.push(this.getMaterialById(element).name)
                    // });
                    // this.competitiveSamples = data.competitiveSamples;
                // } else if (type === entityType.center || this.tab === 0) {
                if (this.visitsConfig.NextVisitNotes) {
                    this.centerNotes = data.nextVisitNotes;
                }
                this.$store.dispatch('materialTransactions/fetchRemaining', { id: data.employeeId }).then((data) => {
                    this.materialsEmployee = data
                })

                // this.visitId = null;
            }).finally(() => {
                this.loadingView[index] = false
            })
        },

        update() {
            this.submitLoading = true
            this.$store.dispatch('visits/updateVisit', {
                id: this.visitId,
                entityId: this.entityIForRow, 
                otherSamples: this.otherSamples, 
                objections: this.objections,
                nextVisitNotes: this.centerNotes,
                purpose: this.nextCall, 
                materialAmounts: this.entriesSamples.map(c => ({ materialId: c.materialId, amount: c.amount })),
                unavailableMaterialIds: this.unavailablesMaterials, 
                competitiveSamples: [this.competitiveSamples], 
                createdAt: this.createdAtForVisit,
                coreMessage: this.coreMessage, 
                durationInMinutes: this.durationInMinutes,
                notes: this.notes
           }).then(() => {
                this.filter()
                this.dialog = false
                this.view = false
           }).finally(() => {
                this.dialog = false
                this.visitId = null
                this.submitLoading = false
           })
        },
        resetFilter() {
            this.$router.replace({
                query: {}
            })
            this.cityId = []
            this.regionIds = []
            this.dateType = '1'
            this.startDate = moment().startOf('month').format('YYYY-MM-DD')
            this.endDate = moment().endOf('month').format('YYYY-MM-DD')
            this.date = moment().format('YYYY-MM-DD')
            this.medicalRepId = []
        },

        getMedical() {
            if (this.regionIds.length) {
                this.loadingMedicalForRegion = true
                this.medicalRepIds = []
                this.$store.dispatch('medicalreps/fetchAllBrief', { regionIds: this.regionIds }).then((data) => {
                    this.medicalRepsForRegion = data
                }).finally(() => {
                    this.loadingMedicalForRegion = false
                })
            }
        },

        printReport (id, isPosDevice) {
            this.loading = true
            this.$store.dispatch('exporter/printReport', { 
                visitId: id,
                posDevice: isPosDevice
            }).finally(() => {
                this.loading = false
            })
        }
    },

    created() {
        this.loading = true
        if (this.$route.query.date) {
            if (this.$route.query.endDate !== null) {
                this.dateType = '2'
                this.endDate = this.$route.query.endDate
                this.startDate = this.$route.query.date
                this.date = moment().format('YYYY-MM-DD')
            } else {
                this.dateType = '1'
                this.date = this.$route.query.date
                this.startDate = moment().startOf('month').format('YYYY-MM-DD')
                this.endDate = moment().endOf('month').format('YYYY-MM-DD')
            }
        } else {
            this.startDate = moment().startOf('month').format('YYYY-MM-DD')
            this.endDate = moment().endOf('month').format('YYYY-MM-DD')
            this.date = moment().format('YYYY-MM-DD')
        }
    
        Promise.all([
            !this.cities.length ? this.$store.dispatch('cities/fetchCityMine', {}).then((data) => {
                this.$store.dispatch('regions/fetchAllRegions', { cities: data })
            }) : null,
            !this.medicalRepsBrief.length ? this.$requestStack.setRequest({
                key: 'medicalreps/fetchAllBrief',
                promise: this.$store.dispatch('medicalreps/fetchAllBrief', true)
            }) : this.$requestStack.getRequest('medicalreps/fetchAllBrief').promise,

            !this.specialties.length ? this.$requestStack.setRequest({
                key: 'specialties/fetchAll',
                promise: this.$store.dispatch('specialties/fetchAll'),
            }) : this.$requestStack.getRequest('specialties/fetchAll').promise,
            
            !this.materials.length ? this.$requestStack.setRequest({
                key: 'materials/fetchAll',
                promise: this.$store.dispatch('materials/fetchAll', true)
            }) : this.$requestStack.getRequest('materials/fetchAll').promise,

            enableVacations && !this.vacationsDayDetails.length ? this.$requestStack.setRequest({
                key: 'vacations/fetchAll',
                promise: this.$store.dispatch('vacations/fetchAll'),
            }) : this.$requestStack.getRequest('vacations/fetchAll').promise,

        ]).catch(() => {
            console.log('error')
        }).then(() => {
            console.log('done')
            this.filter()
        })
    }
}
</script>
